import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
import 'bootstrap/js/dist/tab';

export function initBootstrapRuntime(): void {
  document.documentElement.dataset.bootstrapRuntime = 'ready';
}
